<p class="text-xl mb-2">{{ resolvedTitle }}</p>
<hr [class]="horizontalRuleClass" [style]="horizontalRuleStyle">
<app-load-spinner-wrapper [loading]="loading"/>

<div class="flex w-full min-w-0 max-w-full max-h-[60dvh] flex-col">
<div class="min-h-0 overflow-x-auto overflow-y-auto touch-auto">
<table mat-table [dataSource]="dataSource"
  matSort
  (matSortChange)="onSortChange($event)"
  matSortActive="claimNo"
  matSortDirection="asc"
  matSortDisableClear>
  @for (column of displayedColumns; track column) {
    <ng-container
      [matColumnDef]="column" >
      <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="column === 'dob'"> {{ columnHeaders[column] }} </th>
      <td mat-cell *matCellDef="let row"> {{ getCellValue(row, column) }} </td>
    </ng-container>
  }

  <tr class="sticky top-0 z-10 bg-white" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClicked(row)"></tr>
</table>
</div>
<div class="flex w-full shrink-0 justify-end bg-white table-pagination" *ngIf="totalPages !== 0">
  <app-pagination
    [currentPage]="resourceSortOptions().pageNumber"
    [totalPages]="totalPages"
    (pageChange)="onPageChange($event)"
  />
</div>
</div>

@if (resourceData.isLoading()) {
  <div
    class="w-full flex justify-center my-10"
    >
    <mat-spinner></mat-spinner>
  </div>
}
@if (dataSource.length === 0 && !resourceData.isLoading()) {
  <div
    class="w-full text-center my-10"
    >
    <p class="text-sm">{{emptyTableMessage}}</p>
  </div>
}
